import React from 'react';
import _path from 'ramda/src/path';
import PropTypes from 'prop-types';
import FeedContainer from '../Common/Feed/FeedContainer';
import { withMessage } from '../Common/Message';

const ProfileFeedsContainer = ({ websiteId }) => {
    const query = {
        RecordCount: 100,
        WebsiteId: websiteId,
        GetOnlyPublicReblasts: 'true'
    };

    return (
        <FeedContainer
            datasrc={0}
            requestQuery={query}
            hideCreatePost={true}
            page={_path(['RESAAS', 'User2', 'DomainUrl'], window) === window.domainUrl ? "myprofile" : "userprofile"}
        />
    );
};

ProfileFeedsContainer.propTypes = {
    websiteId: PropTypes.string
};

export default withMessage(ProfileFeedsContainer);
